import React from 'react';

import { iframeLink } from 'core/iframe';

import { StartupIndexView } from './page';
import * as Styled from './styles';

export function StartupIndex(props) {
    const { vars } = props.useRankingStartup;
    const { application } = vars;

    // Termo de Ciência completion: all 6 acknowledgement items checked
    const ackKeys = [
        'realRelationships',
        'validatedByOtherParty',
        'officialPublicationRequiresAudit',
        'auditCost',
        'caseRequirement',
        'awardsOptional'
    ];
    const ack = application?.rulesAcknowledgement || {};
    const hasAllAcks = ackKeys.every(k => ack[k] === true);

    // For startups the audit status is computed, not stored: an early-stage
    // startup is always considered confirmed (no charge); a scaleup must
    // have actually paid. Scaleup is recomputed at view time from the same
    // revenue/investment ranges step2 uses — read from `application`
    // (the ranking-application entry, refreshed on navigation) rather than
    // startupDetails, which can lag behind.
    const revenuesRange = application?.revenuesRange || [];
    const investmentRange = application?.investmentRange || [];
    const isScaleup =
        !!application?.forcedScaleup ||
        (Number(investmentRange[0]) === 0 &&
            Number(investmentRange[1]) >= 20000000) ||
        (Number(revenuesRange[0]) === 0 &&
            Number(revenuesRange[1]) >= 20000000) ||
        Number(revenuesRange[0]) >= 2500000 ||
        Number(investmentRange[0]) >= 2500000;
    const auditConfirmed =
        !isScaleup || application?.auditEnrollment?.status === 'confirmed';

    // Create the steps for this index
    const steps = [
        {
            step: 1,
            href: '/ranking/latam/startup/step1',
            text: props.t('StartupIndex.step1'),
            isBlocked: false,
            isCompleted: application.steps.step1 || false
        },
        {
            step: 2,
            href: '/ranking/latam/startup/step2',
            text: props.t('StartupIndex.step2'),
            isBlocked: !application.steps.step1,
            isCompleted: application.steps.step2 || false
        },
        {
            step: 3,
            href: '/ranking/latam/startup/step3',
            text: props.t('StartupIndex.step3'),
            isBlocked: !application.steps.step2,
            isCompleted: application.steps.step3 || false
        },
        {
            step: 4,
            href: '/ranking/latam/startup/step4',
            text: props.t('StartupIndex.step4'),
            isBlocked: !application.steps.step3,
            isCompleted: application.steps.step4 || false
        },
        {
            step: 5,
            href: '/ranking/latam/startup/step5',
            text: props.t('StartupIndex.step5'),
            isBlocked: !application.steps.step4,
            isCompleted: application.steps.step5 || false
        },
        {
            step: 6,
            href: '/ranking/latam/startup/step6',
            text: props.t('StartupIndex.step6'),
            isBlocked: !application.steps.step5,
            isCompleted: application.steps.step6 || false
        },
        {
            step: 7,
            href: '/ranking/latam/startup/step7',
            text: props.t('StartupIndex.step7'),
            isBlocked: !application.steps.step6,
            isCompleted: application.steps.step7 || false
        },
        {
            step: 8,
            href: '/ranking/latam/startup/step8',
            text: props.t('StartupIndex.step8'),
            isBlocked: !application.steps.step7,
            isCompleted: application.steps.step8 || false
        },
        {
            step: 9,
            href: '/ranking/latam/startup/step9',
            text: props.t('StartupIndex.step9'),
            isBlocked: !application.steps.step8,
            isCompleted: !!application?.steps?.step9,
            ...(!application?.steps?.step9 && application.steps.step8 ? { icon: 'fas fa-exclamation-triangle', type: 'warning' } : {})
        },
        {
            step: 10,
            href: '/ranking/latam/startup/step10',
            text: props.t('StartupIndex.step10'),
            isBlocked: false,
            isCompleted: hasAllAcks,
            ...(!hasAllAcks && application.steps.step8 ? { icon: 'fas fa-exclamation-triangle', type: 'warning' } : {})
        },
        {
            step: 11,
            href: '/ranking/latam/startup/step11',
            text: props.t('StartupIndex.step11'),
            isBlocked: !hasAllAcks,
            isCompleted: auditConfirmed,
            ...(!auditConfirmed && hasAllAcks
                ? { icon: 'fas fa-exclamation-triangle', type: 'warning' }
                : {})
        }
    ];

    // Create a list for the support links
    const actions = [
        {
            id: 1,
            href: iframeLink('http://www.openstartups.net/site/ranking/sobre.html'),
            text: props.t('StartupIndex.RankingAbout')
        },
        {
            id: 2,
            href: '/support',
            text: props.t('StartupIndex.HelpAndSupport')
        }
    ];

    const propsView = { ...props, actions, steps };
    return (
        <Styled.StartupIndex>
            <StartupIndexView {...propsView} />
        </Styled.StartupIndex>
    );
}
